import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { cloudServicesData } from './CloudServices.data';
import type { CloudServicesProps } from './CloudServices.types';
import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';

export const CloudServices = ({
  offerRef,
  ...props
}: CloudServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="red" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={cloudServicesData.mainText}
        description={cloudServicesData.description}
        data={cloudServicesData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
